// Logs a user in using redux toolkit query
// Differs from other API calls in that it uses redux toolkit query
// all our other API calls use a custom function callApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IAuthenticateResponse } from "src/interfaces/IAuthResponse";
import { runtimeConfig } from "./runtimeConfig";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({
    baseUrl: runtimeConfig.apiUrl,
  }),
  endpoints: (builder) => ({
    loginUser: builder.mutation<
      IAuthenticateResponse,
      {
        acctId: string;
        username: string;
        password: string;
        deviceId: string;
      }
    >({
      query: (body: {
        acctId: string;
        username: string;
        password: string;
        deviceId: string;
      }) => {
        return {
          url: "/users/authenticate",
          method: "POST",
          body,
          credentials: "include",
        };
      },
    }),
    logoutUser: builder.mutation({
      query: () => {
        return {
          url: "/users/logout",
          method: "POST",
          credentials: "include", // Ensure cookies are sent with the request
        };
      },
    }),
  }),
});

export const { useLoginUserMutation, useLogoutUserMutation } = authApi;
